import { safeGet } from "src/shared/utils";
import { parseBigNumber } from "src/utils/parseNumber";

export const sortImComMetricsByDelta = (a, b) => {
  const metricIdA = safeGet(a, "metricId");
  const isAPositive = safeGet(a, "isPositive");
  const isBPositive = safeGet(b, "isPositive");
  const metricIdB = safeGet(b, "metricId");

  const aPerformanceId = parseBigNumber(safeGet(a, "performanceChartIds[1]"));
  const bPerformanceId = parseBigNumber(safeGet(b, "performanceChartIds[1]"));

  const aValue = safeGet(a, "currentChart.data.data.data[0]", 0);
  const bValue = safeGet(b, "currentChart.data.data.data[0]", 0);

  if (isAPositive || isBPositive) {
    // if metric is positive, sort delta in descending order
    const aDiff = aPerformanceId - aValue;
    const bDiff = bPerformanceId - bValue;
    return bDiff - aDiff;
  }

  const aDiff = aPerformanceId - aValue;
  const bDiff = bPerformanceId - bValue;

  return aDiff - bDiff; // if metric is negative, sort delta in ascending order
};

export const getChartNumberStyle = (isPositive: boolean, bigNumber: number, benchmark: number, styles: any) => {
  if (isPositive) {
    if (bigNumber > benchmark) {
      return styles["success"]; // Good if isPositive and value > benchmark
    } else if (bigNumber === benchmark) {
      return styles["warning"]; // Warning if isPositive and value == benchmark
    } else {
      return styles["error"]; // Bad if isPositive and value < benchmark
    }
  } else {
    if (bigNumber < benchmark) {
      return styles["success"]; // Good if !isPositive and value < benchmark
    } else if (bigNumber === benchmark) {
      return styles["warning"]; // Warning if !isPositive and value == benchmark
    } else {
      return styles["error"]; // Bad if !isPositive and value > benchmark
    }
  }
};
